<template>
  <div class="agios">
    <section class="section container">
      <div class="hero">
        <agios-hero-text-box></agios-hero-text-box>
        <agios-pics-compo class="hero__pics"></agios-pics-compo>
      </div>
    </section>

    <section class="section">
      <agios-gallery-horizontal></agios-gallery-horizontal>
    </section>

    <section class="section">
      <div class="container">
        <div class="details">
          <agios-do-text-box class="details__dobox"></agios-do-text-box>
          <agios-see-text-box></agios-see-text-box>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AgiosHeroTextBox from '@/components/layout/AgiosHeroTextBox.vue';
import AgiosDoTextBox from '@/components/layout/AgiosDoTextBox.vue';
import AgiosSeeTextBox from '@/components/layout/AgiosSeeTextBox.vue';
import AgiosPicsCompo from '@/components/layout/AgiosPicsCompo.vue';
import AgiosGalleryHorizontal from '@/components/layout/AgiosGalleryHorizontal.vue';

export default {
  name: 'AgiosNikolaos',
  components: {
    AgiosHeroTextBox,
    AgiosDoTextBox,
    AgiosSeeTextBox,
    AgiosPicsCompo,
    AgiosGalleryHorizontal,
  },
};
</script>

<style scoped lang="scss">
.agios {
  background-color: var(--primary);
}

.hero {
  width: 100%;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.details {
  width: 100%;
  display: flex;
  align-items: flex-start;

  justify-content: space-between;
}

/***** MEDIA QUERIES *****/
@media (max-width: 900px) {
  .hero {
    flex-direction: column;
    min-height: 0;
    &__pics {
      display: none;
    }
  }
}

@media (max-width: 600px) {
  .details {
    flex-direction: column;
    align-items: center;

    &__dobox {
      margin-bottom: 30px;
    }
  }
}
</style>
